// Teksten van het designsysteem (docs/DESIGN.md): pictogramnamen, kleurnamen, componentlabels,
// lege staten en de ontwerpgalerij. Apart bestand zodat nl.ts klein en overzichtelijk blijft.
export const designNl = {
    /** Namen van de pictogrammen (packages/ui-core art.ts); ook alt-tekst en zoekterm. */
    picto: {
        'brush-teeth': 'Tanden poetsen',
        'get-dressed': 'Aankleden',
        shoes: 'Schoenen aan',
        coat: 'Jas aan',
        'wash-hands': 'Handen wassen',
        toilet: 'Naar de wc',
        shower: 'Douchen',
        bath: 'In bad',
        sleep: 'Slapen',
        alarm: 'Wekker',
        prayer: 'Bidden',
        wudu: 'Wudu doen',
        'make-bed': 'Bed opmaken',
        'tidy-up': 'Opruimen',
        'set-table': 'Tafel dekken',
        'clear-table': 'Tafel afruimen',
        dishes: 'Afwassen',
        dishwasher: 'Vaatwasser uitruimen',
        vacuum: 'Stofzuigen',
        sweep: 'Vegen',
        cleaning: 'Schoonmaken',
        windows: 'Ramen lappen',
        laundry: 'Was draaien',
        'fold-laundry': 'Was opvouwen',
        trash: 'Vuilnis buiten zetten',
        recycling: 'Afval scheiden',
        'water-plants': 'Planten water geven',
        garden: 'Tuin',
        'walk-dog': 'Hond uitlaten',
        'feed-cat': 'Kat eten geven',
        'feed-fish': 'Vissen eten geven',
        'feed-rabbit': 'Konijn eten geven',
        mail: 'Post',
        school: 'School',
        backpack: 'Schooltas',
        homework: 'Huiswerk',
        reading: 'Lezen',
        library: 'Bibliotheek',
        lecture: 'Lezing',
        mosque: 'Moskeeles',
        quran: 'Koran',
        computer: 'Computer',
        work: 'Werk',
        'phone-call': 'Bellen',
        calendar: 'Afspraak',
        soccer: 'Voetbal',
        hockey: 'Hockey',
        swimming: 'Zwemmen',
        gymnastics: 'Turnen',
        dance: 'Dansen',
        ballet: 'Ballet',
        tennis: 'Tennis',
        basketball: 'Basketbal',
        judo: 'Judo',
        'horse-riding': 'Paardrijden',
        skating: 'Schaatsen',
        running: 'Hardlopen',
        cycling: 'Fietsen',
        playground: 'Speeltuin',
        'music-lesson': 'Muziekles',
        piano: 'Piano',
        guitar: 'Gitaar',
        violin: 'Viool',
        drums: 'Drummen',
        singing: 'Zingen',
        theater: 'Theater',
        drawing: 'Tekenen',
        painting: 'Schilderen',
        crafts: 'Knutselen',
        puzzle: 'Puzzelen',
        play: 'Spelen',
        gaming: 'Gamen',
        tv: 'Tv kijken',
        'screen-time': 'Schermtijd',
        dentist: 'Tandarts',
        doctor: 'Huisarts',
        hospital: 'Ziekenhuis',
        medicine: 'Medicijnen',
        sick: 'Ziek',
        haircut: 'Kapper',
        birthday: 'Verjaardag',
        party: 'Feestje',
        gift: 'Cadeau',
        wish: 'Wens',
        chat: 'Berichten',
        sohbet: 'Sohbet',
        grandma: 'Oma',
        grandpa: 'Opa',
        family: 'Gezin',
        babysitter: 'Oppas',
        playdate: 'Speelafspraak',
        sleepover: 'Logeren',
        home: 'Thuis',
        holiday: 'Vakantie',
        travel: 'Reizen',
        camping: 'Kamperen',
        zoo: 'Dierentuin',
        museum: 'Museum',
        cinema: 'Bioscoop',
        car: 'Auto',
        bus: 'Bus',
        train: 'Trein',
        walk: 'Wandelen',
        church: 'Kerk',
        shabbat: 'Sjabbat',
        synagogue: 'Synagoge',
        mandir: 'Mandir',
        moon: 'Maan',
        breakfast: 'Ontbijt',
        lunch: 'Lunch',
        dinner: 'Avondeten',
        fruit: 'Fruit',
        drink: 'Drinken',
        cooking: 'Koken',
        baking: 'Bakken',
        groceries: 'Boodschappen',
        'ice-cream': 'IJsje',
        popcorn: 'Filmavond',
        pizza: 'Pizza',
        pancakes: 'Pannenkoeken',
        soup: 'Soep',
        'oven-dish': 'Ovenschotel',
        stamppot: 'Stamppot',
        lasagne: 'Lasagne',
        curry: 'Curry',
        noodles: 'Noedels',
        taco: 'Taco’s',
        wrap: 'Wrap',
        salad: 'Salade',
        hamburger: 'Hamburger',
        fries: 'Friet',
        dumplings: 'Dumplings',
        waffle: 'Wafel',
        pie: 'Taart',
        cake: 'Gebak',
        pudding: 'Toetje',
        banana: 'Banaan',
        pear: 'Peer',
        orange: 'Sinaasappel',
        lemon: 'Citroen',
        strawberry: 'Aardbeien',
        grapes: 'Druiven',
        tomato: 'Tomaat',
        cucumber: 'Komkommer',
        carrot: 'Wortel',
        broccoli: 'Broccoli',
        lettuce: 'Sla',
        'bell-pepper': 'Paprika',
        onion: 'Ui',
        garlic: 'Knoflook',
        potato: 'Aardappelen',
        mushroom: 'Champignons',
        corn: 'Maïs',
        avocado: 'Avocado',
        cheese: 'Kaas',
        butter: 'Boter',
        egg: 'Eieren',
        yoghurt: 'Yoghurt',
        croissant: 'Croissant',
        honey: 'Honing',
        meat: 'Vlees',
        chicken: 'Kip',
        bacon: 'Spekjes',
        fish: 'Vis',
        shrimp: 'Garnalen',
        sausage: 'Worst',
        rice: 'Rijst',
        salt: 'Zout',
        'canned-food': 'Blik',
        peanuts: 'Pinda’s',
        chocolate: 'Chocola',
        cookie: 'Koekjes',
        jar: 'Pot',
        coffee: 'Koffie',
        tea: 'Thee',
        juice: 'Sap',
        water: 'Water',
        'toilet-paper': 'Wc-papier',
        soap: 'Zeep',
        sponge: 'Sponsje',
        basket: 'Mandje',
        'baby-bottle': 'Babyvoeding',
        receipt: 'Bonnetje',
        store: 'Winkel',
        star: 'Ster',
        trophy: 'Beker',
        medal: 'Medaille',
        savings: 'Sparen',
        fox: 'Vos',
        cat: 'Kat',
        rabbit: 'Konijn',
        bear: 'Beer',
        panda: 'Panda',
        koala: 'Koala',
        owl: 'Uil',
        lion: 'Leeuw',
        tiger: 'Tijger',
        monkey: 'Aap',
        unicorn: 'Eenhoorn',
        dino: 'Dino',
        turtle: 'Schildpad',
        frog: 'Kikker',
        hedgehog: 'Egel',
        penguin: 'Pinguïn',
        dolphin: 'Dolfijn',
        butterfly: 'Vlinder',
        rocket: 'Raket',
        sunflower: 'Zonnebloem',
        rainbow: 'Regenboog',
        // Thema's (feat/themas): rustige, abstracte avatars.
        'shape-arch': 'Boog',
        'shape-wave': 'Golven',
        'shape-leaf': 'Blad',
        'shape-hills': 'Heuvels',
        'shape-ring': 'Ring',
        'shape-spark': 'Vonk',
        towel: 'Handdoek',
        underwear: 'Onderbroek',
        socks: 'Sokken',
        'swim-trunks': 'Zwembroek',
        swimsuit: 'Badpak',
        shampoo: 'Shampoo',
        slippers: 'Slippers',
        'football-boots': 'Voetbalschoenen',
        'shin-guards': 'Scheenbeschermers',
        'water-bottle': 'Bidon',
        headscarf: 'Hoofddoek',
        'prayer-cap': 'Takke',
    },
    /**
     * Extra zoekwoorden per pictogram (spatiegescheiden), naast de naam hierboven: de IconPicker
     * zoekt erin en het titelvoorstel (apps/web lib/suggest.ts) gebruikt woorden vanaf 4 letters.
     * Een woordgroep met liggend streepje ("quran_lesson") telt in het voorstel als geheel; geen
     * algemene woorden als "lesson" los opnemen, anders krijgt elke les dit pictogram.
     */
    pictoKeywords: {
        // Oprichter 1 okt: lezing, en sohbet (alleen bij Turks én Islam in het gezinsprofiel).
        lecture: 'lezing lezingen voordracht lecture ders vortrag conference conferentie konferans seminar seminer congres',
        sohbet: 'sohbet sohbeti muhabbet',
        mosque: 'moskee moskeeles masjid islam koran koranles arabisch les camii cami_ders kuran hafizlik',
        prayer: 'bidden gebed gebeden namaz salah salat teravih dua',
        // Golf 2 (oprichter #15): Wudu doen, Turks "abdest almak".
        wudu: 'wudu wudhu woedoe abdest abdest_almak wudu_doen rituele_wassing',
        // 0024: nieuwe geloofspictogrammen (opt-in; zoeken vindt ze altijd, met de reden erbij).
        quran: 'koran koranles kuran quran hafiz hifz tajwid',
        church: 'kerk kerkdienst kerkdiensten christelijk kapel zondagsdienst',
        shabbat: 'sjabbat shabbat sabbat joods',
        synagogue: 'synagoge sjoel joods',
        mandir: 'mandir tempel hindoe hindoeistisch puja',
        moon: 'maan maansikkel halve_maan ramadan',
        // 0031: checklist bij een oproep (Inpakken).
        towel: 'handdoek badhanddoek',
        underwear: 'onderbroek ondergoed',
        socks: 'sokken sok',
        'swim-trunks': 'zwembroek',
        swimsuit: 'badpak zwempak bikini',
        shampoo: 'shampoo douchegel zeep',
        slippers: 'slippers teenslippers badslippers',
        'football-boots': 'voetbalschoenen kicksen noppen',
        'shin-guards': 'scheenbeschermers scheenbeschermer',
        'water-bottle': 'bidon drinkfles waterfles',
        headscarf: 'hoofddoek hijab sjaal',
        'prayer-cap': 'takke gebedsmuts kufi keppeltje muts',
    },
    pictoCategory: {
        routine: 'Dagritme',
        chores: 'Klusjes',
        school: 'School en werk',
        sport: 'Sport',
        hobby: 'Muziek en hobby',
        care: 'Zorg',
        family: 'Familie en uitjes',
        food: 'Eten',
        groceries: 'Boodschappen',
        reward: 'Beloning',
        avatar: 'Dieren en figuren',
        packing: 'Inpakken',
    },
    /** Kleurnamen voor de ColorPicker (Okabe–Ito-sleutels), in gewone taal. */
    color: {
        orange: 'Oranje',
        skyblue: 'Lichtblauw',
        bluishgreen: 'Groen',
        yellow: 'Geel',
        blue: 'Blauw',
        vermillion: 'Rood',
        reddishpurple: 'Roze',
        black: 'Grijs',
    },
    eventCard: {
        allDay: 'Hele dag',
        cancelled: 'Afgelast',
        everyone: 'Iedereen',
        whoDrives: 'Wie rijdt?',
        drives: '{name} rijdt',
        /** Brengen en halen door een ander (release-c r2): "Anne brengt · Baba haalt". */
        splitDrives: '{dropoff} brengt · {pickup} haalt',
        repeat: 'Herhaalt',
        moved: 'Verplaatst',
        changed: 'Gewijzigd',
    },
    check: {
        label: '{task}: klaar?',
        confirm: 'Klaar!',
        undo: 'Oeps',
    },
    points: {
        earned: { one: '{count} punt', other: '{count} punten' },
        reserved: '{count} gereserveerd',
    },
    progress: '{done} van {total} klaar',
    celebrate: {
        task: 'Goed gedaan, {name}!',
        allDone: 'Alles klaar!',
        /** Rustig, buiten het thema Kinderen (oprichter okt 2026: geen uitroeptekens of lof). */
        calm: {
            confirm: 'Klaar',
            task: 'Gedaan door {name}',
            allDone: 'Alles is klaar voor vandaag',
        },
    },
    colorPicker: {
        label: 'Kleur',
        takenBy: 'Al gekozen door {name}',
        takenOne: '{color} is al van {name}',
    },
    iconPicker: {
        label: 'Pictogram',
        search: 'Zoek een pictogram',
        none: 'Geen pictogram',
        noResults: 'Niets gevonden voor “{query}”',
        all: 'Alles',
        more: '+{count} meer',
    },
    toast: {
        undo: 'Ongedaan maken',
        dismiss: 'Melding sluiten',
    },
    dialog: {
        close: 'Sluiten',
        fullScreen: 'Volledig scherm',
        smallScreen: 'Kleiner maken',
    },
    calendar: {
        weekShort: 'wk',
        more: '+{count} meer',
        moreShort: '+{count}',
        now: 'Nu',
    },
    /** Afspraak- en taakeditor (DESIGN.md §8.W4–W6). */
    editor: {
        title: 'Titel',
        titleHint: 'Kort en duidelijk, bijvoorbeeld Zwemles',
        repeat: 'Herhalen',
        repeatNone: 'Niet',
        repeatDaily: 'Elke dag',
        repeatWeekly: 'Elke week op {weekday}',
        repeatMonthly: 'Elke maand',
        duplicate: 'Dupliceren',
        approvalRequired: 'Goedkeuring nodig',
        approvalHint: 'Papa of mama keurt de taak goed voordat de punten tellen.',
        deleteQuestion: '{title} verwijderen?',
        repeatsWeekly: 'Deze afspraak herhaalt elke week.',
    },
    /** Bereikvraag bij herhalingen (ONTWERP.md §5.3). */
    scope: {
        editTitle: 'Wat wil je wijzigen?',
        deleteTitle: 'Wat wil je verwijderen?',
        this: 'Alleen deze keer',
        following: 'Deze en volgende',
        all: 'De hele reeks',
        times: { one: '{count} keer', other: '{count} keer' },
        from: 'vanaf {date}',
    },
    view: {
        label: 'Weergave',
        day: 'Dag',
        week: 'Week',
        month: 'Maand',
    },
    inbox: {
        label: 'Goedkeuren',
        open: 'Open',
        done: 'Afgehandeld',
    },
    /** Lege staten en foutstaten (DESIGN.md §6): titel kort, uitleg één zin, geen schuld. */
    empty: {
        welcomeTitle: 'Welkom thuis',
        welcomeBody: 'Samen de week overzien, zonder gedoe. We beginnen met je gezin.',
        emptyDayTitle: 'Vandaag niets gepland',
        emptyDayBody: 'Een rustige dag. Tijd voor iets leuks?',
        noTasksTitle: 'Geen taken vandaag',
        noTasksBody: 'Lekker vrij!',
        allDoneTitle: 'Alles is klaar',
        allDoneBody: 'Er staat niets meer open.',
        offlineTitle: 'Even geen verbinding',
        offlineBody: 'Je ziet de laatste stand. Het komt vanzelf weer goed.',
        nightTitle: 'Slaap lekker',
        nightBody: 'Morgen om {time}: {title}',
        rewardsTitle: 'Nog geen beloningen',
        rewardsBody: 'Bedenk samen iets om voor te sparen.',
        inviteTitle: 'Nodig je partner uit',
        inviteBody: 'Samen plannen gaat makkelijker. Stuur een uitnodiging per e-mail.',
        oopsTitle: 'Oeps, dat ging mis',
        oopsBody: 'Probeer het nog een keer. Lukt het niet? Laad de pagina opnieuw.',
        pairTitle: 'Koppel de tablet',
        pairBody: 'Open het gezinsbord op de tablet en vul de code hier in.',
    },
    /** Bronvermelding van het beeld: alles eigen werk (docs/LICENSES.md, docs/ux/pictogrammen.md). */
    credits: 'Pictogrammen, iconen en illustraties: AMUMIN',
    /** Ontwerpgalerij /_ontwerp (alleen in development). */
    gallery: {
        title: 'Ontwerpgalerij',
        intro: 'Alle bouwstenen van het gezinsbord op één plek: tokens, componenten, pictogrammen en illustraties. Alleen zichtbaar in de ontwikkelomgeving.',
        theme: 'Thema',
        themeLight: 'Dag',
        themeDark: 'Avond',
        themeNight: 'Nacht',
        colors: 'Kleuren',
        memberColors: 'Lidkleuren',
        neutrals: 'Neutralen',
        semantic: 'Betekenis',
        typography: 'Typografie',
        spacing: 'Ruimte en vormen',
        kiosk: 'Kiosk-bouwstenen',
        web: 'Webapp-bouwstenen',
        icons: 'Iconen',
        pictograms: 'Pictogrammen',
        illustrations: 'Illustraties',
        sample: 'Voorbeeld',
    },
};
//# sourceMappingURL=design.nl.js.map